import { render, staticRenderFns } from "./FeedbackMessageForm.vue?vue&type=template&id=263f0b21&"
import script from "./FeedbackMessageForm.vue?vue&type=script&lang=js&"
export * from "./FeedbackMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports